<app-email-list
    (newEmail)="newEmail()"
    [newEmailPermission]="'contacts.maintain-contacts.send-contact-email'"
    [references]="[{ id: contact.ID_Contact, type: 'contact' }]"></app-email-list>
